import { Injectable, inject } from '@angular/core';
import {BaseTask, EmployeeView} from "planner-shared";
import {TimeService} from "@shared";

@Injectable({
    providedIn: 'root'
})
export class TimeWindowService {
    private readonly timeService = inject(TimeService);


    public isTaskOverlappingEmployeeTimeWindow(task: BaseTask, formFromTime: string, formToTime: string, employeeView: EmployeeView, requiresConversion: boolean): boolean {
        let taskFromTime = task.fromTime;
        let taskToTime = task.toTime;
        if (requiresConversion) {
            taskFromTime = this.timeService.convertTime(taskFromTime, true);
            taskToTime = this.timeService.convertTime(taskToTime, true);
        }
        const employeeTaskFromDate = new Date(task.fromDate + "T" + taskFromTime);
        const employeeTaskToDate = new Date(task.toDate + "T" + taskToTime);
        const formFromDate = new Date(employeeView.fromDate + "T" + formFromTime);
        const formToDate = new Date(employeeView.fromDate + "T" + formToTime);

        if (employeeView.fromDate < employeeView.toDate && formFromTime > formToTime) {
            formToDate.setDate(formToDate.getDate() + 1);
        }
        return formFromDate <= employeeTaskFromDate && formToDate >= employeeTaskFromDate ||
            formFromDate >= employeeTaskFromDate && formFromDate <= employeeTaskToDate;
    }

}
